export function getOrderTradeTypeStr(code) {
  // NONE(0, "无"),
  // PHYSICS(1, "实体商品");
  switch (code) {
    case 0:
      return '无';
    case 1:
      return '实体商品';
    default:
      return '未知';
  }
}

export function getOrderPayStateStr(code) {
  // NOTPAY(1, "未支付"),
  // REVOKED(30, ""),
  // USERPAYING(40, "用户正在支付"),
  // PAYERROR(50, "支付错误"),
  // SUCCESS(60, "支付成功"),
  // CLOSED(70, "支付关闭"),
  // TRADE_FINISHED(80, "交易结束"),
  // REFUNDING(100, "退款中"),
  // REFUNDED(110, "已退款");

  switch (code) {
    case 1:
      return '未支付';
    case 30:
      return '';
    case 40:
      return '用户正在支付';
    case 50:
      return '支付错误';
    case 60:
      return '支付成功';
    case 70:
      return '支付关闭';
    case 80:
      return '交易结束';
    case 100:
      return '退款中';
    case 110:
      return '已退款';
    default:
      return '';
  }
}

export function getOrderPayTypeStr(code) {
  // NONE(0, "无"),
  // WXPay(1, "微信"),
  // ALIPay(2, "支付宝"),
  // APPLEInner(3, "苹果内购");

  switch (code) {
    case 0:
      return '无';
    case 1:
      return '微信';
    case 2:
      return '支付宝';
    case 3:
      return '苹果内购';
    default:
      return '未知';
  }
}

export function getOrderTradeStateStr(code) {
  // WAIT_PAY(0, "待付款"),
  // WAIT_SHIPMENT(3, "待发货"),
  // WAIT_CONFIRM_RECEIPT(6, "待收货"),
  // CANCEL(10, "取消"),
  // SUCCESS(20, "完成"),
  // REFUNDING(30, "退款中"),
  // REFUNDED(40, "已退款");

  switch (code) {
    case 0:
      return '待付款';
    case 3:
      return '待发货';
    case 6:
      return '待收货';
    case 10:
      return '取消';
    case 20:
      return '完成';
    case 30:
      return '退款中';
    case 40:
      return '已退款';
    default:
      return '未知';
  }
}

export function getAuctionOrderTradeStateStr(code) {
  switch (code) {
    case 0:
      return '竞拍成功';
    case 3:
      return '待发货';
    case 6:
      return '待收货';
    case 10:
      return '已违约';
    case 20:
      return '完成';
    case 30:
      return '退款中';
    case 40:
      return '已退款';
    default:
      return '未知';
  }
}
